import { Card, Typography, Row, Col, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const { Paragraph } = Typography;

const Dashboard = () => {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate()

  useEffect(() => {
    const userDataString = sessionStorage.getItem('userData');
    if (userDataString) {
      const userDataObject = JSON.parse(userDataString);
      setUserData(userDataObject);
    }
  }, []);

  return (
    <div className=" min-h-[calc(100vh-100px)] flex justify-center items-start rounded-xl">
      <div className="w-full p-4 md:p-6 lg:p-8">
        {/* Welcome Header */}
        <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-center bg-blue-200 text-blue-800 p-3 md:p-4 mb-4 md:mb-6 lg:mb-8 rounded-xl md:rounded-2xl shadow-sm">
          Welcome to {userData?.clinic_name || "Our"} Patient Portal
        </h1>

        {/* Information Card */}
        <Card className="p-3 md:p-5 lg:p-6 rounded-xl md:rounded-3xl border border-gray-200 shadow-md">
          <div className="text-center mb-4 md:mb-6">
            <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2">
              Your Personalized Healthcare Hub
            </h2>
            <p className="text-sm md:text-base text-gray-600">
              Access all your medical reports, track your vitals, and stay informed with ease.
            </p>
          </div>

          {/* Paragraphs */}
          <div className="space-y-3 md:space-y-4">
            <Paragraph className="text-base md:text-lg text-gray-700 leading-relaxed">
              Welcome to your personal patient portal. Here, you'll access all your medical reports and receive updates on basic healthcare vitals from your provider.
            </Paragraph>
            <Paragraph className="text-base md:text-lg text-gray-700 leading-relaxed">
              Take advantage of this secure online service provided by your healthcare provider, with the assurance that your personal information is encrypted and stored securely.
            </Paragraph>
            <Paragraph className="text-base md:text-lg font-semibold text-red-600 leading-relaxed">
              ⚠️ Remember! In case of a life-threatening emergency, always call your local emergency services (e.g. 911 in USA)
            </Paragraph>
            <Paragraph className="text-base md:text-lg text-gray-700 leading-relaxed">
              Below are some helpful tips to navigate the portal:
            </Paragraph>
          </div>

          {/* List of Features */}
          <Row gutter={[16, 16]} className="mt-4">
            <Col xs={24} md={12}>
            <Tooltip title="Click here to view the latest updates on your vitals and health metrics.">
              <div className="bg-blue-50 p-4 rounded-lg shadow-sm h-full cursor-pointer" onClick={()=> navigate("/vital-signs")}>
                <h3 className="text-lg font-medium text-blue-700 mb-2">Basic Vitals</h3>
                <p className="text-gray-700">View the latest updates on your vitals and health metrics.</p>
              </div>
              </Tooltip>
            </Col>
            <Col xs={24} md={12}>
            <Tooltip title="Click here to access your most recent prescriptions and medication details.">
              <div className="bg-green-50 p-4 rounded-lg shadow-sm h-full cursor-pointer"  onClick={()=> navigate("/medications")}>
                <h3 className="text-lg font-medium text-green-700 mb-2">Prescriptions</h3>
                <p className="text-gray-700">Access your most recent prescriptions and medication details.</p>
              </div>
              </Tooltip>
            </Col>
            <Col xs={24} md={12}>
            <Tooltip title="Click here to view all your requested lab orders">
              <div className="bg-purple-50 p-4 rounded-lg shadow-sm h-full cursor-pointer" onClick={()=> navigate("/ordered-labs")}>
                <h3 className="text-lg font-medium text-purple-700 mb-2">Ordered Labs</h3>
                <p className="text-gray-700">View all your requested lab tests and upcoming appointments.</p>
              </div>
              </Tooltip>
            </Col>
            <Col xs={24} md={12}>
            <Tooltip title="Click here to view your recent lab results">
              <div className="bg-amber-50 p-4 rounded-lg shadow-sm h-full cursor-pointer" onClick={()=> navigate("/lab-results")}>
                <h3 className="text-lg font-medium text-amber-700 mb-2">Lab Results</h3>
                <p className="text-gray-700">Check out your recent lab results and historical data.</p>
              </div>
              </Tooltip>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
